// Vintage-style anchor mark used as the nautical accent across the site.
// Stroke-only, single line weight, fits the editorial aesthetic.
export default function AnchorMark({ size = 120, color = "#15243D", className = "" }) {
  return (
    <svg
      viewBox="0 0 120 160"
      width={size}
      height={(size * 160) / 120}
      fill="none"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {/* Top ring */}
      <circle cx="60" cy="14" r="7" />
      <line x1="60" y1="21" x2="60" y2="34" />
      {/* Crossbar */}
      <line x1="38" y1="34" x2="82" y2="34" />
      <line x1="38" y1="32" x2="38" y2="36" />
      <line x1="82" y1="32" x2="82" y2="36" />
      {/* Vertical shaft */}
      <line x1="60" y1="34" x2="60" y2="118" />
      {/* Lower arc (the fluke base) */}
      <path d="M18 100 Q60 148 102 100" />
      {/* Flukes / barbs */}
      <line x1="18" y1="100" x2="10" y2="92" />
      <line x1="18" y1="100" x2="26" y2="94" />
      <line x1="102" y1="100" x2="110" y2="92" />
      <line x1="102" y1="100" x2="94" y2="94" />
      {/* Tiny rope detail above the ring */}
      <path d="M53 8 Q60 4 67 8" />
    </svg>
  );
}
